import { GetFilterInput } from '@deltek/specification-client/core/Models/projectItem'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Skeleton from '@material-ui/lab/Skeleton'
import clsx from 'clsx'
import React from 'react'

const useLoadStateStyles = makeStyles((theme: Theme) => ({
    loadStateContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gridGap: 4,
        marginTop: theme.spacing(0.5),
    },
    itemContainer: {
        minHeigh: 135,
        position: 'relative',
        backgroundColor: theme.palette.common.white,
        '& > :nth-child(1), :nth-child(2)': {
            marginBottom: theme.spacing(0.3),
        },
    },
}))

interface RecentProjectLoadStateInterface {
    projectFilterValues?: Partial<GetFilterInput>[]
}

const RecentProjectsLoadState: React.FC<RecentProjectLoadStateInterface> = ({
    projectFilterValues,
}) => {
    const classes = useLoadStateStyles()
    const placeholderItems = Array.from(Array(7))
    return (
        <div
            className={classes.loadStateContainer}
            data-testid="recentProjectsLoadState"
        >
            {placeholderItems.map((_: any, index: number) => (
                <div
                    key={`loaderItem-${index}`}
                    className={clsx(
                        classes.itemContainer,
                        'projectGridItemLoading'
                    )}
                >
                    <Skeleton variant="rect" width="100%" height="130px" />
                    <Skeleton variant="rect" width="100%" height="30px" />

                    {projectFilterValues &&
                    projectFilterValues.length &&
                    isProjectNumberFilterApplied(projectFilterValues) ? (
                        <Skeleton
                            data-testid="numberSkeleton"
                            variant="rect"
                            width="100%"
                            height="30px"
                        />
                    ) : null}
                </div>
            ))}
        </div>
    )
}

export default RecentProjectsLoadState

const isProjectNumberFilterApplied = (
    projectFilterValues: Partial<GetFilterInput>[] | undefined
) => {
    if (projectFilterValues && projectFilterValues.length) {
        const value = projectFilterValues.find(
            (item: Partial<GetFilterInput>) => {
                return item.itemField === 'number'
            }
        )
        if (value && value.filterValues?.length) {
            return true
        }
    }
    return false
}
